// 导出 myMixins 函数
import PayApi from "@/components/Api/pay.js";
export const walletMixing = {
  data() {
    return {
      balanceTotalObj: {},
      filterCriteria: {
        orderNumber: null, //订单编号
        describe: null, //说明
        createName: null, //下单人
        source: null, //支付渠道 //0 微信支付 1 支付宝支付 2 钱包支付 3 线下转账
        price: null, //金额
        createTimeStart: null, //开始时间
        createTimeEnd: null, //结束时间
        balanceTypes: null, //【2,8】是支出  //【3,10】是退款
        planId:null,
        dateArr: [],
      },
    };
  },

  methods: {
    getBalanceTotal(data) {
      new PayApi("pay")
        .balanceTotalBySearch(data, "GET")
        .then((res) => {
          console.log(res, "看看接口返回的数据");
          if (res.status == 200) {
            this.balanceTotalObj = res.data;
          } else {
            this.$message.error(res.statusText);
          }
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "系统异常!",
          });
        });
    },
    search() {
      let obj = JSON.parse(JSON.stringify(this.filterCriteria));
      if (obj.dateArr && obj.dateArr.length > 0) {
        obj.createTimeStart = this.filterCriteria.dateArr[0];
        obj.createTimeEnd = this.filterCriteria.dateArr[1];
      }
      if (obj.balanceTypes) {
        obj.balanceTypes = obj.balanceTypes.split(",");
      }
      this.getBalanceTotal(obj);
      this.$emit("search", obj);
    },
    reset() {
      this.filterCriteria = {
        orderNumber: null, //订单编号
        describe: null, //说明
        createName: null, //下单人
        source: null, //支付渠道 //0 微信支付 1 支付宝支付 2 钱包支付 3 线下转账
        price: null, //金额
        createTimeStart: null, //开始时间
        createTimeEnd: null, //结束时间
        balanceTypes: null, //
        dateArr: [],
      };
      this.$emit("search", this.filterCriteria);
    },
  },
  mounted() {
    this.getBalanceTotal(this.filterCriteria);
  },
};
